import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Archive, ArchiveRestore, Eye } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { dateTimeBR } from "../../lib/format";
import { Card, Loading } from "../../components/common";
import { Button } from "../../components/ui/button";

export default function BoArchived() {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => api.get("/admin/companies", { params: { archived: true } }).then((r) => setRows(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const restore = async (c) => {
    try { await api.post(`/admin/companies/${c.id}/archive`, { archived: false }); toast.success(`${c.trade_name} voltou para a Central de Clientes`); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!rows) return <Loading />;
  return (
    <div className="space-y-6" data-testid="bo-archived">
      <div><div className="label-xs">Backoffice</div><h1 className="font-display text-3xl font-semibold tracking-tight">Empresas arquivadas</h1>
        <p className="text-sm text-slate-500 mt-1">Os dados ficam guardados. Os usuários da empresa ficam sem acesso até a restauração.</p></div>
      {rows.length ? <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">{rows.map((c) => (
        <Card key={c.id} className="p-5 space-y-3" testid={`archived-${c.id}`}>
          <div className="flex items-start gap-3"><span className="h-9 w-9 shrink-0 rounded-lg bg-slate-100 text-slate-500 flex items-center justify-center"><Archive className="h-4 w-4" /></span>
            <div className="min-w-0"><div className="font-display font-semibold uppercase tracking-tight truncate" data-testid={`archived-name-${c.id}`}>{c.trade_name}</div>
              <div className="text-xs text-slate-500 truncate">{c.legal_name}{c.cnpj ? ` · ${c.cnpj}` : ""}</div></div></div>
          <div className="text-xs text-slate-500" data-testid={`archived-when-${c.id}`}>Arquivada em {dateTimeBR(c.archived_at)}{c.archived_by ? ` · por ${c.archived_by}` : ""}</div>
          <div className="flex gap-2 pt-1">
            <Button asChild size="sm" variant="outline"><Link to={`/backoffice/clientes/${c.id}`} data-testid={`archived-view-${c.id}`}><Eye className="h-3.5 w-3.5 mr-1.5" />Ver dados</Link></Button>
            <Button size="sm" onClick={() => restore(c)} data-testid={`archived-restore-${c.id}`}><ArchiveRestore className="h-3.5 w-3.5 mr-1.5" />Restaurar</Button>
          </div>
        </Card>))}</div>
        : <Card className="p-10 text-center text-sm text-slate-500" testid="archived-empty">Nenhuma empresa arquivada.</Card>}
    </div>);
}
